import http from '@/config/api';
import router from '@/router';

export default {
  async payQrCode(_, payload) {
    const directory = payload?.directory || router.currentRoute.value?.params.directory;
    const response = await http
      .post(`event/${directory}/point/${payload.qrPointId}/pay`, payload, { checkClearQueryUrl: true })
      .then(
        (res) => res.data,
        (err) => ({
          error: {
            ...err,
          },
        })
      );
    return response;
  },
  async payParentQrCode(_, payload) {
    const response = await http
      .post(`event/point/${payload.qrPointId}/pay`, payload, { checkClearQueryUrl: true })
      .then(
        (res) => res.data,
        (err) => ({
          error: {
            ...err,
          },
        })
      );
    return response;
  },
};
